import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {CurrencyService} from "@core/shared/services/currency.service";

@Injectable({
    providedIn: 'root'
})
export class CurrencyItemsResolver {

    constructor(
        private _currencyService: CurrencyService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {

        return this._currencyService.getItemsAPI();
    }
}
